<template>
  <div>
    <lte-navibar @viewProjectList="viewProjectList"></lte-navibar>
    <lte-sidebar :slideMenuItems="slideMenuItems"></lte-sidebar>
    <lte-contentwrap :ref="`contentwrap`"></lte-contentwrap>
  </div>
</template>

<script>
import LTENaviBar from './NaviBar.vue'
import LTESideBar from './SideBar.vue'
import LTEContentWrap from './ContentWrap.vue'
import slideMenuItems from '../../lib/slideMenuItems.js'

export default {
  name: 'DefaultLayout',
  data () {
    return {
      slideMenuItems: slideMenuItems.items
    }
  },
  components: {
    'lte-navibar': LTENaviBar,
    'lte-sidebar': LTESideBar,
    'lte-contentwrap': LTEContentWrap
  },
  methods: {
    viewProjectList: function() {
      this.$refs[`contentwrap`].viewProjectList()
    }
  },
  mounted() {
    let body = document.getElementsByTagName("BODY")[0];
    body.className = "sidebar-mini skin-black fixed";
  }
}

</script>

<style lang="scss" scoped>
.page-enter-active, .page-leave-active {
  transition: opacity 0.5s, transform 0.5s;
}
.page-enter, .page-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Layout/DefaultLayout.vue